import _extends from '@babel/runtime/helpers/extends';
import _slicedToArray from '@babel/runtime/helpers/slicedToArray';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import EnterpriseIcon, { DollarSignIcon } from '@enterprise-ui/icons';
import classnames from 'classnames';
import React__default, { useState, useCallback, useEffect } from 'react';

var _excluded = ["id", "className", "display", "error", "highlight", "onUpdate", "disabled", "required", "allowDecimals", "type", "value"];
var FormCurrency = function FormCurrency(_ref, ref) {
  var id = _ref.id,
    className = _ref.className,
    _ref$display = _ref.display,
    display = _ref$display === void 0 ? 'dollar' : _ref$display,
    error = _ref.error,
    highlight = _ref.highlight,
    onUpdate = _ref.onUpdate,
    disabled = _ref.disabled,
    required = _ref.required,
    allowDecimals = _ref.allowDecimals,
    _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'text' : _ref$type,
    _ref$value = _ref.value,
    value = _ref$value === void 0 ? '' : _ref$value,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var _useState = useState(''),
    _useState2 = _slicedToArray(_useState, 2),
    currencyValue = _useState2[0],
    setCurrencyValue = _useState2[1];
  var formatWholeNumberCurrency = function formatWholeNumberCurrency(value) {
    var formatter;
    if (value) {
      switch (display) {
        case 'inr':
          {
            formatter = new Intl.NumberFormat('en-IN', {
              currency: 'INR',
              maximumFractionDigits: 0,
              minimumFractionDigits: 0,
              style: 'currency'
            });
            break;
          }
        default:
          formatter = new Intl.NumberFormat('en-US', {
            currency: 'USD',
            maximumFractionDigits: 0,
            minimumFractionDigits: 0,
            style: 'currency'
          });
      }
      var result = formatter.format(value);
      result = result.replace(/\$/g, '');
      return result;
    }
    return value;
  };
  var getFormattedCurrency = useCallback(function (inputVal) {
    if (allowDecimals && inputVal.toString().indexOf('.') !== -1) {
      var intVal = inputVal.toString().split('.')[0].replace(/\s/g, '');
      var decimalVal = inputVal.toString().split('.')[1].replace(/\s/g, '');
      return formatWholeNumberCurrency(intVal) + '.' + decimalVal.slice(0, 2);
    } else {
      return formatWholeNumberCurrency(inputVal);
    }
  }, /* eslint-disable */
  [allowDecimals]);
  var checkValidFormat = useCallback(function (currentValue) {
    // this must always be a string or it will error out and not render
    // JS .replaceAll is not fully supported
    var inputVal = !currentValue || currentValue === null ? '' : currentValue.toString().replace(/,/g, '');
    if (isNaN(inputVal)) {
      // if the provided value includes chars that are not supported
      console.error("The provided value ".concat(inputVal, " is invalid. Please supply a valid number."));
      return false;
    } else if (!isNaN(inputVal) && !allowDecimals && inputVal.toString().indexOf('.') !== -1) {
      // if the provided value includes decimals and should not
      console.error("The provided value ".concat(inputVal, " is invalid. Please supply a valid whole number."));
      return false;
    } else {
      // if the provided value looks good, pass it through
      return inputVal;
    }
  }, /* eslint-disable */
  [allowDecimals]);

  // value updates from external changes
  useEffect(function () {
    var inputVal = handleNegativeStateChange(value);
    inputVal = checkValidFormat(inputVal);
    if (inputVal !== false) {
      setCurrencyValue(inputVal);
    }
    /* eslint-disable */
  }, [value, allowDecimals]);
  var finalClasses = classnames('C-Input C-Currency', {
    isDisabled: disabled,
    isErrored: error,
    isHighlighted: highlight
  }, className);
  var handleNegativeStateChange = function handleNegativeStateChange(inputValue) {
    var currentValue = parseFloat(currencyValue);
    if (inputValue === '-') {
      var currentValSign = Math.sign(currentValue);
      if (currentValSign === -0 || currentValSign === -1 && currentValue !== '') return '';
      return '-0';
    }
    return inputValue;
  };

  // value updates from internal changes
  var handleOnChange = function handleOnChange(event) {
    var inputVal = handleNegativeStateChange(event.target.value);
    inputVal = checkValidFormat(inputVal);
    if (inputVal !== false) {
      setCurrencyValue(inputVal);
      onUpdate && onUpdate(id, inputVal);
    }
  };
  var renderCurrencyIcon = function renderCurrencyIcon() {
    switch (display) {
      case 'inr':
        return '₹';
      default:
        return /*#__PURE__*/React__default.createElement(EnterpriseIcon, {
          size: "inline",
          icon: DollarSignIcon
        });
    }
  };
  return /*#__PURE__*/React__default.createElement("div", {
    className: finalClasses
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "C-Currency__Icon"
  }, renderCurrencyIcon()), /*#__PURE__*/React__default.createElement("input", _extends({
    "aria-label": display === "inr" ? "Units in Indian Rupees" : "Units in US Dollars",
    className: "C-Currency__Input",
    id: id,
    disabled: disabled,
    type: type,
    required: required,
    "aria-required": required ? 'true' : 'false',
    value: getFormattedCurrency(currencyValue),
    onChange: handleOnChange
  }, otherProps)), !allowDecimals && /*#__PURE__*/React__default.createElement("label", {
    className: "C-Currency__Decimal"
  }, ".00"));
};
FormCurrency.displayName = 'Form.Currency';
var InputCurrency = /*#__PURE__*/React__default.forwardRef(FormCurrency);

export { InputCurrency as default };
